import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgMore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 4",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M2 0C.9 0 0 .9 0 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 0C6.9 0 6 .9 6 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	})
});
export default SvgMore;
